import { FormatConfig } from '@y42/model';
import { ConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { Y42SeriesModel } from './common';
import { ColorByArea, ColorModel } from './sub-models/color.model';
import { DatosAxisPointer } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';
import { LabelLine } from './sub-models/pie-sub-models/label.model';
import { SizeModel } from './sub-models/size.model';
import { TooltipModel } from './sub-models/tooltip.model';

export class PieSettingsModel extends BaseEchartsSettingsModel<PieSeriesModel> {
  constructor(
    public show_as_donut = false,
    public size: [] | [SizeModel] = [],
    public conditionalFormattingRules?: ConditionalFormattingRule[],
    public colorBy?: {
      area: ColorByArea;
      hiddenValues: Record<string, boolean>;
    },
    series: PieSeriesModel[] = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    breakdowns?: fieldId[],
  ) {
    super(series, show_legend, axisPointer, [], breakdowns);
  }
}

export class PieSeriesModel implements Y42SeriesModel {
  constructor(
    public field_id: fieldId | null = null,
    public mark: MarkTypeEnum = MarkTypeEnum.Bar,
    public stack_name = 1, // need as unique id
    public color: ColorModel = new ColorModel(),
    public label: LabelModel = new LabelModel(),
    public labelLine?: LabelLine,
    public tooltip: TooltipModel = new TooltipModel(),
    public show_right_axis = false,
    public format = 'inherit',
    public size = 50,
    public formatConfig?: FormatConfig,
    public hideFalsyValues = true,
  ) {}
}
